import component from './list.component';
import item from './item/item.component';
import search from './search/search.component';

export default angular.module('mpdx.contacts.list', [component, item, search]).name;
